import script from "./calling.vue?vue&type=script&lang=ts&setup=true"
export * from "./calling.vue?vue&type=script&lang=ts&setup=true"

import "./calling.vue?vue&type=style&index=0&id=15792af0&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15792af0"]])

export default __exports__